/** Monta objeto parcial a partir de `data` usando a árvore `dirtyFields` do react-hook-form (objetos aninhados). */
export function pickDirtyNested<T extends Record<string, unknown>>(
	data: T,
	dirty: object | boolean | undefined,
): Partial<T> | undefined {
	if (dirty === true) {
		return data;
	}
	if (!dirty || typeof dirty !== 'object') {
		return undefined;
	}
	const out = {} as Partial<T>;
	for (const key of Object.keys(dirty)) {
		const subDirty = (dirty as Record<string, unknown>)[key];
		const val = data[key as keyof T];
		if (subDirty === true) {
			(out as Record<string, unknown>)[key] = val;
		} else if (
			subDirty &&
			typeof subDirty === 'object' &&
			val !== null &&
			typeof val === 'object' &&
			!Array.isArray(val)
		) {
			const nested = pickDirtyNested(
				val as Record<string, unknown>,
				subDirty,
			);
			if (nested !== undefined && Object.keys(nested).length > 0) {
				(out as Record<string, unknown>)[key] = nested;
			}
		}
	}
	return Object.keys(out).length > 0 ? out : undefined;
}

/** PATCH: mantém só chaves cujo valor (pós-normalização) difere do snapshot inicial. */
export function pickChangedShallow<T extends Record<string, unknown>>(
	current: T,
	initial: Partial<T> | null | undefined,
): Partial<T> {
	if (!initial) return current;
	const body = {} as Partial<T>;
	for (const key of Object.keys(current) as Array<keyof T>) {
		const k = key as keyof T;
		if (current[k] !== initial[k]) {
			(body as Record<string, unknown>)[k as string] = current[k];
		}
	}
	return body;
}
